import type { CatalogTree } from '../types';

export const onboarding = {
  // The nine step titles of merchant screens §3.1 (the wizard frame), by step number.
  steps: {
    '1': 'İşletme',
    '2': 'Mağaza altyapısı',
    '3': 'WhatsApp',
    '4': 'Instagram',
    '5': 'Asistan ayarları',
    '6': 'Deneme sohbeti',
    '7': 'Kurulum ve bildirimler',
    '8': 'Plan ve ödeme',
    '9': 'Yayına al',
  },
  frame: {
    progress: 'Kurulum ilerlemesi',
    progressValue: '{done} / 9',
    stepList: 'Kurulum adımları',
    marks: { pending: 'Bekliyor', done: 'Tamamlandı', skipped: 'Atlandı' },
    back: 'Geri',
    continue: 'Devam et',
    skip: 'Şimdilik atla',
    notVerified: 'Devam etmek için e-posta adresinizi doğrulayın.',
    support: 'Operatörden yardım iste',
  },
  business: {
    sector: 'Sektör',
    sectors: { gold: 'Altın', jewelry: 'Mücevher', silver: 'Gümüş' },
    contact_name: 'Yetkili adı',
    phone: 'Telefon',
    address: {
      label: 'Mağaza adresi',
      line1: 'Adres satırı 1',
      line2: 'Adres satırı 2',
      district: 'İlçe',
      city: 'İl',
      postal_code: 'Posta kodu',
    },
    addressHoursText: 'Adres ve çalışma saatleri metni',
    alwaysAvailable: 'Personel her zaman ulaşılabilir',
    text: {
      hours: 'Çalışma saatleri: {schedule}',
      always: 'Personelimiz her zaman ulaşılabilir.',
      days: { mon: 'Pzt', tue: 'Sal', wed: 'Çar', thu: 'Per', fri: 'Cum', sat: 'Cmt', sun: 'Paz' },
    },
  },
  assistant: {
    policies: 'Mağaza politikaları',
    handoff: 'Personele aktarılacak konular ve çalışma saatleri',
    voice: 'Ses',
    editHours: 'Çalışma saatlerini düzenle',
    save: 'Kaydet ve devam et',
  },
  testChat: {
    note: 'Bu sohbet gerçek bir müşteriye gitmez; asistan mağazanızdan eşitlenen gerçek verilerle yanıt verir.',
  },
  install: {
    title: 'Ana ekrana ekle',
    button: 'Ana ekrana ekle',
    installed: 'Panel yüklendi',
    ios: "Safari'de Paylaş → Ana Ekrana Ekle'ye dokunun; panel ana ekranınızda bir uygulama gibi açılır.",
    unavailable:
      'Bu tarayıcı ana ekrana eklemeyi şu an sunmuyor; tarayıcı menüsünden ekleyebilirsiniz.',
    pushTitle: 'Bildirimlere izin ver',
    pushButton: 'Bildirimleri aç',
  },
  billing: {
    plan: 'Plan',
    details: 'Fatura bilgileri',
    fields: {
      legal_name: 'Ünvan',
      tax_id: 'Vergi numarası',
      tax_office: 'Vergi dairesi',
      invoice_email: 'Fatura e-postası',
    },
    eFatura: 'e-Fatura mükellefiyim',
    note: 'Faturalar yalnızca işletmelere kesilir.',
    pay: 'Ödemeye geç',
    waiting: 'Ödeme onayı bekleniyor…',
    started: 'Aboneliğiniz başladı: {plan}, {interval}. Faturanız e-postanıza gönderilecek.',
    declined: 'Kart reddedildi. Başka bir kartla tekrar deneyin.',
    active: 'Aboneliğiniz aktif.',
    checkoutOff: 'Aboneliğinizi ESNAF AI ekibi etkinleştirir.',
  },
  goLive: {
    button: 'Yayına al',
    live: 'Asistan yayında.',
    channels: 'Kanallar ve yanıt modu',
    noChannel: "Henüz bağlı kanal yok; Entegrasyonlar'dan sonra da bağlayabilirsiniz.",
    summary: 'Kurulum özeti',
    links: {
      store: 'Mağaza altyapısı',
      whatsapp: 'WhatsApp',
      instagram: 'Instagram',
      policies: 'Asistan ayarları ve politikalar',
      notifications: 'Kurulum ve bildirimler',
    },
  },
  channel: {
    planLimit: 'Planınız {n} kanal içeriyor.',
    reconnect: 'Yeniden bağlan',
    retest: 'Yeniden test et',
    instagramLogin: 'Instagram ile giriş yap',
  },
  store: {
    choose: 'Adaptör seçin',
    prerequisite: 'Önce gerekli: {prerequisite}',
    test: 'Test',
    import: 'İlk içe aktarma',
    prerequisiteMissing: 'Mağazanızda {eklenti} etkin değil. Etkinleştirip Yeniden dene deyin.',
    permissionMissing: 'Verilen erişim yetersiz.',
    retry: 'Yeniden dene',
    importFailed: 'İçe aktarma tamamlanamadı; bağlantı sorunlu görünüyor.',
    empty: 'Mağazanızda ürün bulunamadı.',
    change: 'Mağazayı değiştir',
    disconnectTitle: '{name} bağlantısını kes',
    disconnectText:
      'Mağazadan eşitleme durur; ürün kopyanız ve siparişleriniz silinmez, fiyatlar süre dolunca eski sayılır.',
    disconnect: 'Bağlantıyı kes',
    quality: 'Veri kalitesi',
    qualityList: 'Eksik verili ürünler',
    qualitySentence:
      'Eksik verili ürünleri mağazanızda düzeltin; asistan eksik veriyi tahmin etmez.',
  },
} as const satisfies CatalogTree;
